import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';



class PaymentResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sfOrderId: 0,
            sfInvoiceId: 0,
            receiptReference: "",
            errorMessage: "",
            errorOccurred: false,
            headerText: ""
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.getQueryParams = this.getQueryParams.bind(this);
        this.formatView = this.formatView.bind(this);
    }

    getQueryParams() {
        // initialize an empty object
        let result = {};
        // get URL query string
        let params = window.location.search;
        // remove the '?' character
        params = params.substr(1);
        let queryParamArray = params.split('&');
        // iterate over parameter array
        queryParamArray.forEach(function (queryParam) {
            // split the query parameter over '='
            let item = queryParam.split("=");
            result[item[0]] = decodeURIComponent(item[1]);
        });
        // return result object
        return result;
    }

    async componentWillMount() {
        var params = this.getQueryParams();
        let response = await this.dl.Post("/shop/processpaymentresponse", params, false);

        this.setState({
            sfOrderId: response.sfOrderId,
            sfInvoiceId: response.sfInvoiceId,
            receiptReference: response.receiptReference,
            errorOccurred: response.errorOccurred,
            headerText: response.data,
            errorMessage: response.errorMessage
        })
        this.props.loaderOff()
        if (!response.errorOccurred) {
            this.props.updateCartCount(0);
        }
    }

    formatView() {
        if (!this.state.errorOccurred) {
            return (
                <div>
                    <Header headerText={this.state.headerText}
                        subHeaderText="Thank you for your order, we appreciate your business."
                        hideSearch={true}
                    />
                    <br />
                    <MDBRow>
                        <MDBCol xl="12">
                            <span style={{ fontSize: "14px" }}>Your Order Number is: <strong>{this.state.sfOrderId}</strong></span><br />
                            {this.state.sfInvoiceId == -1 ? (<div><span style={{ fontSize: "14px" }}>Unable to process invoice; your distributor must process this invoice</span><br /></div>) : (<div><span style={{ fontSize: "14px" }}>Your Invoice Number is: <strong>{this.state.sfInvoiceId}</strong></span><br /></div>)}
                            <span style={{ fontSize: "14px" }}>Your Receipt Reference is: <strong>{this.state.receiptReference}</strong></span><br />
                        </MDBCol>
                    </MDBRow>
                </div>
            )
        } else {
            return (
                <div>
                    <Header headerText="Transaction Not Successful"
                        hideSearch={true}
                    />
                    <br />
                    <MDBRow>
                        <MDBCol xl="12">
                            <span style={{ fontSize: "14px" }}>Reason: <strong>{this.state.errorMessage}</strong></span><br />

                        </MDBCol>
                    </MDBRow>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {this.formatView()}
            </div>
        )
    }
}

export default PaymentResponse;